// pages/TutorialsPage.js
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './TutorialsPage.css'
import SchoolIcon from '@mui/icons-material/School'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import NoteAddIcon from '@mui/icons-material/NoteAdd'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import { tutorialsData } from '../tutorialsData'
import { useTutorialProgress } from '../hooks/useTutorialProgress'

function TutorialsPage() {
  const navigate = useNavigate()
  const { getAllProgress } = useTutorialProgress()
  const [allProgress, setAllProgress] = useState({})
  const [isLoaded, setIsLoaded] = useState(false)

  const tutorialIcons = {
    'wissen-hinzufuegen': <NoteAddIcon />,
    'wissen-moderieren-und-verwalten': <FactCheckIcon />
  }

  useEffect(() => {
    setAllProgress(getAllProgress())
    // Fade-in animation
    setTimeout(() => setIsLoaded(true), 100)
  }, [getAllProgress])

  const handleTutorialClick = (tutorialId) => {
    navigate(`/tutorials/${tutorialId}`)
  }

  const handleKeyDown = (e, tutorialId) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleTutorialClick(tutorialId)
    }
  }

  return (
    <div className='tut-page'>
      {/* Hero Section */}
      <div className='tut-hero'>
        <div className='tut-hero-content'>
          <SchoolIcon className='tut-hero-icon' />
          <h1>Anleitungen</h1>
          <p className='tut-hero-subtitle'>
            Lerne alle Funktionen von engKnowledge kennen
          </p>
        </div>
      </div>

      {/* Tutorials Grid */}
      <div className='tut-container'>
        <div className={`tut-grid ${isLoaded ? 'loaded' : ''}`}>
          {tutorialsData.map((tutorial, index) => {
            const progress = allProgress[tutorial.id]
            const isCompleted = progress?.completed || false
            const icon = tutorialIcons[tutorial.id] || tutorial.icon
            
            return (
              <div
                key={tutorial.id}
                className={`tut-card ${isCompleted ? 'completed' : ''}`}
                onClick={() => handleTutorialClick(tutorial.id)}
                onKeyDown={(e) => handleKeyDown(e, tutorial.id)}
                role='button'
                tabIndex={0}
                aria-label={`Tutorial öffnen: ${tutorial.title}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {isCompleted && (
                  <div className='tut-card-completed-badge'>
                    <CheckCircleIcon fontSize='small' />
                    <span>Abgeschlossen</span>
                  </div>
                )}
                <div className='tut-card-icon'>{icon}</div>
                <div className='tut-card-content'>
                  <div className='tut-card-header'>
                    <span className='tut-card-category'>{tutorial.category}</span>
                    <span className='tut-card-duration'>
                      <AccessTimeIcon fontSize='small' />
                      {tutorial.duration}
                    </span>
                  </div>
                  <h2 className='tut-card-title'>{tutorial.title}</h2>
                  <p className='tut-card-description'>{tutorial.description}</p>
                  <div className='tut-card-footer'>
                    <span className='tut-card-steps'>
                      {tutorial.steps.length} Schritte
                    </span>
                    <ArrowForwardIcon className='tut-card-arrow' />
                  </div>
                </div>
              </div>
            )
          })}
        </div>

        {/* Placeholder for more tutorials */}
        {tutorialsData.length === 0 && (
          <div className='tut-empty'>
            <SchoolIcon style={{ fontSize: 64, color: '#cbd5e0' }} />
            <p>Noch keine Anleitungen verfügbar</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default TutorialsPage